import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_COMPETITIONCLUBS,
  SET_COMPETITIONCLUBS,
  SET_ERROR,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  clubs: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPETITIONCLUBS:
      return {
        ...state,
        isReady: true,
        isError: false,
        clubs: action.data,
      };
    case RESET_COMPETITIONCLUBS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (state) => state.isReady);

export const selectIsError = createSelector(getState, (state) => state.isError);

export const selectCompetitionClubs = createSelector(getState, (state) =>
  state.clubs.sort((a, b) => a.name.localeCompare(b.name))
);

reducerRegistry.register(REDUCER_NAME, reducer);
